// Same rules streams_api_admin applies to a stream type's columns file: the workers
// create the table columns from it (str -> VARCHAR(40), float -> REAL).
const COLUMN_NAME = /^[a-z_][a-z0-9_]*$/;

// {name: type} -> error message, or "" if valid
export const validateColumns = (columns) => {
  if (!columns || typeof columns !== "object" || Array.isArray(columns) || Object.keys(columns).length === 0) {
    return 'The columns must be a non-empty JSON object like {"column_name": "float"}.';
  }
  const badNames = Object.keys(columns).filter((name) => !COLUMN_NAME.test(name));
  if (badNames.length) {
    return `Invalid column names (lowercase letters, digits and _ only): ${badNames.join(", ")}`;
  }
  const badTypes = Object.entries(columns).filter(([, type]) => type !== "str" && type !== "float");
  if (badTypes.length) {
    return `Invalid column types (only "str" or "float"): ${badTypes.map(([n, t]) => `${n}: ${t}`).join(", ")}`;
  }
  return "";
};

// {name: type} <-> [{key, type}] (the form's field list)
export const columnsToFields = (columns) =>
  Object.entries(columns || {}).map(([key, type]) => ({ key, type }));

export const fieldsToColumns = (fields) =>
  fields.reduce((acc, field) => {
    if (field.key && field.type) acc[field.key.trim()] = field.type;
    return acc;
  }, {});
